export default "__VITE_ASSET__EKBnLpqT__"